import BaseModel from './BaseModel';
import moment from 'moment';

import cinech from '../assets/images/integrations/cinech.png';
import eventival from '../assets/images/integrations/eventival.png';
import json from '../assets/images/integrations/json.png';
import kronos from '../assets/images/integrations/kronos.png';
import raw from '../assets/images/integrations/file.png';

/** Class representing a tag. */
class Log extends BaseModel {
    static BOOKING_CONFIRM_TYPE        = 'confirm_booking';
    static UNBOOK_TYPE                 = 'unbook';
    static TICKET_ACTIVATE_TYPE        = 'activate';
    static TICKET_DELETE_TYPE          = 'delete';
    static TICKET_BLOCK_TYPE           = 'block';
    static TICKET_UNBLOCK_TYPE         = 'unblock';
    static TICKET_CHECKIN_TYPE         = 'checkin';
    static TICKET_CHECKOUT_TYPE        = 'checkout';
    static TICKET_CHANGE_TYPE_TYPE     = 'change_type';
    static EMAIL_SENT_TYPE             = 'email_sent';
    static EMAIL_ERROR_TYPE            = 'email_error';
    static EMAIL_OPENED_TYPE           = 'email_opened';
    static SCREENINGS_IMPORT           = 'screenings_import';
    static TICKETS_IMPORT              = 'tickets_import';
    static PLACES_IMPORT               = 'places_import';
    static HEALTH_CHECK_RUN            = 'health_checks_run';

    constructor(properties) {
        super(properties || {});

        if (this.created_at)
            this.created_at = moment(this.created_at);

        ['inserted', 'updated', 'activated', 'invalid'].forEach(property => {
            if (this[property])
                this[property] = (this[property] || []).map(entry => {
                    if ('start_at' in entry)
                        entry.start_at = moment(entry.start_at);
                    if ('stop_at' in entry)
                        entry.stop_at = moment(entry.stop_at);

                    return entry;
                });
        });
    }

    sourceIcone() {
        switch (this.source) {
            case 'cinech':
                return cinech;
            case 'eventival':
                return eventival;
            case 'json':
                return json;
            case 'kronos':
                return kronos;
            case 'raw':
                return raw;
        }

        return null;
    }

    sourceName(t) {
        if (!this.source)
            return null;

        return t(`logs.source.${this.source}`);
    }
}

export default Log;
